import React, { useCallback, useEffect, useState } from 'react';
import { ServerInterface } from "src/store/mine_craft/serversSlice";
import { fetchServerPlayersTimeline } from "src/actions/mine_craft/serversActions";
import { useAppDispatch } from "src/store/hooks";

import Card from "src/componets/Card";
import { Segmented } from 'antd';
import AreaChart, { BLUE, countLabel } from "./_AreaChart";

type IntervalKey = 'hour' | 'day';
const INTERVALS: { value: IntervalKey, label: string }[] = [
  { value: 'hour', label: '48h' },
  { value: 'day',  label: '30d' }
];

interface TimelinePoint {
  ts: string;
  players: number;
}

// Distinct players per hour/day bucket — reuses the Usage cards' chart
// primitive (and its `.v-srv-charts` styling scope).
const _PlayersChart = ({ server }: { server: ServerInterface }) => {
  const dispatch = useAppDispatch();

  const [range, setRange] = useState<IntervalKey>('hour');
  const [buckets, setBuckets] = useState<TimelinePoint[]>([]);
  const [loading, setLoading] = useState(false);

  const serverId = server.id;

  const load = useCallback(async () => {
    setLoading(true);
    const resultAction = await dispatch(fetchServerPlayersTimeline({ id: serverId, interval: range }));
    setLoading(false);

    if (fetchServerPlayersTimeline.fulfilled.match(resultAction)) {
      setBuckets(resultAction.payload?.buckets || []);
    }
  }, [serverId, range, dispatch]);

  useEffect(() => {
    load().catch(console.error);
  }, [load]);

  const values = buckets.map(bucket => bucket.players || 0);

  return (
    <Card className='v-mb-15'>
      <div className='v-srv-charts'>
        <div className='o-bar'>
          <h6 className='v-content-title'>Player activity</h6>
          <Segmented
            size='small'
            value={range}
            onChange={value => setRange(value as IntervalKey)}
            options={INTERVALS}
          />
        </div>

        <div className='o-row o-single'>
          {loading && !buckets.length && <div className='o-card o-skeleton' />}

          {(!loading || !!buckets.length) &&
            <div className='o-card'>
              <div className='o-head'><h6>Distinct players per {range}</h6></div>
              {buckets.length
                ? <AreaChart id='activity' format={countLabel} series={[{ color: BLUE, values }]} />
                : <div className='o-none'>No activity yet</div>}
            </div>
          }
        </div>
      </div>
    </Card>
  );
};

export default _PlayersChart;
